<template>
  <DetailsAsideLayout>
    <template v-slot:detailsContent>
      <MessageContainer
        level="info"
      >
        <p>
          Multi-Factor Authentication can be enforced on your selection of LDAP Applications.
          Learn More:
          <Link
            :href="ldapMFAKbLink"
            target="_blank"
            text="Configuring MFA for LDAP"
          />.
        </p>
      </MessageContainer>
      <section :class="$style.sectionRoot">
        <header :class="$style.sectionHeader">
          LDAP Instance
        </header>
        <div :class="$style.sectionContent">
          <TextareaValidator
            :config="{
              attribute: 'distinguishedName',
              label: 'ORG DN',
              name: 'Description',
              readonly: true,
              value: distinguishedName,
            }"
          />
          <KnowledgeBaseArticle
            :infoText="infoText"
            :kbLink="ldapKbLink"
          />
        </div>
      </section>
      <SambaAuthentication />
      <LdapCustomAttributes
        v-if="ldapCustomAttributes"
      />
    </template>
  </DetailsAsideLayout>
</template>
<script>
import { Link } from '@jumpcloud/ui-components';

import * as Constants from 'client/util/Constants';
import { featureFlags } from 'client/store/modules/FeatureFlagsModule';
import { mapGetters, mapState } from 'vuex';
import DetailsAsideLayout from 'client/components/AsidePanel/Details/DetailsAsideLayout.vue';
import KbArticleUrls from 'client/util/Constants/KbArticleUrls';
import KnowledgeBaseArticle from 'client/components/FormValidation/KnowledgeBaseArticle.vue';
import LdapCustomAttributes from 'client/directories/Ldap/LdapCustomAttributes.vue';
import MessageContainer from 'client/components/MessageContainer/MessageContainer.vue';
import SambaAuthentication from 'client/directories/Ldap/SambaAuthentication.vue';
import TextareaValidator from 'client/components/FormValidation/TextareaValidator.vue';

const {
  ItemTypeConsts,
  ItemTypeRoutes,
  StoreModelMap,
} = Constants;
const { ldap } = ItemTypeConsts;
const ldapModel = StoreModelMap[ldap];
const { ldapCustomAttributes } = featureFlags;

export default {
  name: 'LdapDetails',

  inject: ['$validator'],

  components: {
    DetailsAsideLayout,
    KnowledgeBaseArticle,
    LdapCustomAttributes,
    Link,
    MessageContainer,
    SambaAuthentication,
    TextareaValidator,
  },

  data() {
    return {
      infoText: 'To learn how to easily add, disable, and update user accounts. Read our',
      ldapKbLink: KbArticleUrls.LdapKB,
      ldapMFAKbLink: KbArticleUrls.ldapMFAConfiguration,
    };
  },

  computed: {
    ...mapGetters(ldapModel, [
      'distinguishedName',
    ]),

    ...mapState('FeatureFlagsModule', {
      [ldapCustomAttributes]: state => state.betaFeatures[ldapCustomAttributes],
    }),

    conditionalPoliciesLink() {
      return ItemTypeRoutes.authNPolicies;
    },
  },
};
</script>
<style module>
@import '../../css/sections.css';
</style>
